import { Button, Popconfirm, Tooltip } from 'antd';
import { useNavigate } from "react-router-dom";
import { EyeFilled, EditFilled, DeleteFilled, WarningFilled, MergeFilled, CloseCircleFilled, CheckCircleFilled } from '@ant-design/icons';

const Columns = (hasPermission, showModal, handleDelete, filters, isSuperuser, hasAnyRole) => {
  const navigate = useNavigate();

  /* const renderStatusIcon = (active) => {
    return active ? (
      <Tooltip title="Activo">
        <CheckCircleFilled  style={{ color: '#63c000', fontSize: 15 }} />
      </Tooltip>
    ) : (
      <Tooltip title="Inactivo">
        <CloseCircleFilled style={{ color: 'red', fontSize: 15 }} />
      </Tooltip>
    );
  }; */

  return [
    {
      title: "Nombre",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '15%',
    },
    {
      title: "Descripción",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => (a.description || "").localeCompare(b.description || ""),
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } 
      }),
      showSorterTooltip: false,
      width: '20%',
      render: (text) => {
        if (!text) return <span style={{ color: '#999' }}>Sin descripción</span>;

        const truncatedText = text.length > 80 ? `${text.substring(0, 80)}...` : text;

        return text.length > 40 ? (
          <Tooltip title={text}>
            <span>{truncatedText}</span>
          </Tooltip>
        ) : (
          <span>{truncatedText}</span>
        );
      },
    },
    {
      title: "Riesgo",
      /* title: (
        <Tooltip title="Riesgo">
          <WarningFilled style={{ color: "#FF4D4F" }} />
        </Tooltip>
      ), */
      dataIndex: "risk",
      key: "risk",
      sorter: (a, b) => (a.risk?.name || '').localeCompare(b.risk?.name || ''),
      render: (text, record) => record.risk?.name || 'N/A',
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '8%',
    },
    {
      title: "Categoría",
      dataIndex: "category",
      key: "category",
      sorter: (a, b) => (a.category?.name || '').localeCompare(b.category?.name || ''),
      filterSearch: true,
      filters: filters.categories.map(cat => ({
        text: cat.name,
        value: cat.name
      })),
      onFilter: (value, record) => record.category?.name === value,
      render: (text, record) => record.category?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '10%',
    },    
    {
      title: "Tipo",
      dataIndex: "type",
      key: "type",
      sorter: (a, b) => (a.type?.name || '').localeCompare(b.type?.name || ''),
      filters: filters.types.map(t => ({
        text: t.name,
        value: t.name
      })),
      //filteredValue: filters.dashboardTypeFilter ? [filters.dashboardTypeFilter] : undefined,
      defaultFilteredValue: filters.filteredTypeValue,
      onFilter: (value, record) => record.type?.name === value,
      render: (type) => type?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '8%',
    },
    {
      title: "Prioridad",
      dataIndex: "priority",
      key: "priority",
      sorter: (a, b) => (a.priority?.name || '').localeCompare(b.priority?.name || ''),
      filters: filters.priorities.map(p => ({
        text: p.name,
        value: p.name
      })),
      //filteredValue: filters.dashboardPriorityFilter ? [filters.dashboardPriorityFilter] : undefined,
      defaultFilteredValue: filters.filteredPriorityValue,
      onFilter: (value, record) => record.priority?.name === value,
      render: (priority) => priority?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      width: '10%',
      align: 'center',
    },   
    {
      title: "Responsable",
      dataIndex: "area",
      key: "area",
      sorter: (a, b) => (a.area?.name || '').localeCompare(b.area?.name || ''),
      filters: filters.areas.map(area => ({
        text: area.name,
        value: area.name
      })),
      defaultFilteredValue: filters.dashboardAreasFilter,
      onFilter: (value, record) => record.area?.name === value,
      render: (text, record) => record.area?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '12%',
    },
    {
      title: "Framework",
      dataIndex: "framework",
      key: "framework",
      sorter: (a, b) => (a.framework?.name || '').localeCompare(b.framework?.name || ''),
      filters: filters.frameworks.map(fw => ({
        text: fw.name,
        value: fw.name
      })),
      filterSearch: true,
      onFilter: (value, record) => record.framework?.name === value,
      render: (text, record) => record.framework?.name || 'N/A',
      onHeaderCell: () => ({
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '10%',
    },
    /* {
      title: "Estado",
      dataIndex: "is_active",
      key: "is_active",
      sorter: (a, b) => Number(a.is_active) - Number(b.is_active),
      onHeaderCell: () => ({ style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      filters: [
        {
          text: (<><CheckCircleFilled style={{ color: '#63c000', marginRight: 5 }} />Activo</>),
          value: true,
        },
        {
          text: (<><CloseCircleFilled style={{ color: 'red', marginRight: 5 }} />Inactivo</>),
          value: false,
        },
      ],
      onFilter: (value, record) => record.is_active === value,
      render: (active) => renderStatusIcon(active ?? true),
      width: '10%',
      align: 'center',
    }, */
    {
      title: "Acciones",
      key: "actions",
      render: (_, record) => {
        const canUpdate = isSuperuser || hasPermission("controls", "update", record.area?.id);
        const canDelete = isSuperuser || hasPermission("controls", "delete", record.area?.id);
        const canViewAssignControls = isSuperuser || hasPermission("assignment", "read", record.area?.id);

        return (
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
            <Button 
              type="link" 
              style={{ color: '#006939', fontSize: 18,  padding: '0px 4px' }} 
              onClick={() => navigate(`/controls/${record.code}`)}
            >
              <Tooltip title="Ver Control"><EyeFilled /></Tooltip>
            </Button>
            <Button
              disabled={!canUpdate}
              style={{ color: canUpdate ? '#006939' : '#999999', fontSize: 18, padding: '0px 4px' }}
              type="link" 
              onClick={() => showModal(record)}>
              <Tooltip title="Editar Control"><EditFilled /></Tooltip>
            </Button>
            <Button 
              type="link"
              disabled={!canViewAssignControls}
              style={{ color: canViewAssignControls ? '#F5A623' : '#999999', fontSize: 18, padding: '0px 2px' }}
              onClick={() => navigate(`/assignment?tab=2&control=${encodeURIComponent(record.title)}`)}
            >
              <Tooltip title="Asignar Activos">
                <MergeFilled />
              </Tooltip>
            </Button>
            <Popconfirm 
              overlayClassName="custom-popconfirm"
              title="¿Seguro que deseas eliminar este Control?" 
              onConfirm={() => handleDelete(record.code)}
              disabled={!canDelete}
            >
              <Button
                type="link"
                disabled={!canDelete}
                style={{ color: canDelete ? '#006939' : '#999999', fontSize: 18, padding: '0px 4px' }}
              >
                <Tooltip title="Eliminar Control"><DeleteFilled /></Tooltip>
              </Button>
            </Popconfirm>
          </div>
        )
      },
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#E0F8AD', color: '#006939', fontWeight: 'bold', textAlign: 'center' } 
      }),
      align: 'center',
      width: '10%',
    }    
  ];
};

export default Columns;